import BaseEntity from './BaseEntity';
import CommitList from './CommitList';
import EmptyCommitSimple from './EmptyEntities/EmptyCommitSimple';
export default class Branch extends BaseEntity {
    constructor(branch, commits, defects, codeCoverage) {
        super();
        this.active = true; // TODO: find if it will be in the graphql response
        this.main = false;
        this.id = this.parseProperty(branch, 'id');
        this.errorsCount = this.parseProperty(branch, 'errorsCount');
        this.main = this.parseProperty(branch, 'main');
        this.name = this.parseProperty(branch, 'name');
        this.warningsCount = this.parseProperty(branch, 'warningsCount');
        this.commitList = new CommitList(this.parseProperty(commits, 'commits'), this.parseProperty(commits, 'limit'), this.parseProperty(commits, 'moreCommits'), this.parseProperty(commits, 'currentPage'), defects, codeCoverage);
        // @ts-expect-error Property 'length' does not exist on type '{}'
        const lastCommit = commits && commits.commits?.length ? this.getLastCommit() : null;
        this.lastCommit = this.parseProperty(branch, 'lastCommit') ?? lastCommit?.hash ?? null;
        this.lastCommitStatus = this.parseProperty(branch, 'lastCommitStatus') ?? lastCommit?.status ?? null;
        this.lastCommitUpdatedAt = lastCommit?.updatedAt ?? '';
    }
    getIssueCount() {
        return this.errorsCount + this.warningsCount;
    }
    getLastCommit() {
        if (this.commitList.commits.length) {
            return this.commitList.commits[0];
        }
        throw new Error(`Branch (${this.id}: ${this.name}) has no commits.`);
    }
    getCommitByHash(commitHash) {
        const commit = this.commitList.commits.find(({ hash }) => hash === commitHash);
        if (!commit) {
            throw new Error(`Commit (${commitHash}) doesn't exist.`);
        }
        return commit;
    }
    getCommitById(commitId) {
        const commit = this.commitList.commits.find(({ id }) => id === commitId);
        if (!commit) {
            return new EmptyCommitSimple();
        }
        return commit;
    }
}
